// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const corvisquire: PokeData = {
  "id": 822,
  "name": "corvisquire",
  "height": 8,
  "weight": 160,
  "base_experience": 128,
  "types": [
    PokeType.FLYING
  ],
  "api_moves": [
    "fury-attack",
    "leer",
    "peck",
    "drill-peck",
    "scary-face",
    "swagger",
    "taunt",
    "pluck",
    "brave-bird",
    "hone-claws",
    "power-trip"
  ],
  "moves": [
    "leer",
    "peck",
    "scary-face",
    "brave-bird",
    "gust",
    "tailwind",
    "roost",
    "acrobatics",
    "aerial-ace",
    "chatter",
    "air-slash",
    "hurricane",
    "sky-attack"
  ],
  "evolution_chain": {
    "id": 434,
    "item": null,
    "species": [
      {
        "name": "rookidee",
        "order": 821,
        "types": [
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "corvisquire",
        "order": 822,
        "types": [
          PokeType.FLYING
        ],
        "evolves_from_species_id": 821,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "corviknight",
        "order": 823,
        "types": [
          PokeType.FLYING,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 822,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61.5,
    "speed": 77,
    "ability_power": 67
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
